import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Cookies from 'js-cookie';
import enUsTrans from './en-us.json'
import zhCnTrans from './zh-cn.json'
import jaJpTrans from './ja-jp.json'
import { initReactI18next } from 'react-i18next'

const STORAGE_KEY = 'i18nextLng';

i18n.use(LanguageDetector) // 获取当前浏览器语言
  .use(initReactI18next)
  .init({
    // 资源文件
    resources: {
      en: {
        translation: enUsTrans
      },
      zh: {
        translation: zhCnTrans
      },
      ja: {
        translation: jaJpTrans
      }
    },
    detection: {
      caches: [],
    },
    supportedLngs: ['en', 'ja'],
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    }
  })

const url = new URL(window.location.href);
const [, ...domains] = url.host.split('.');
const domain = domains.join('.');

export function setBackendLanguage (lang: string) {
  Cookies.set( 'SSW_LOCALE', lang, { domain: `.${domain}`, secure: true, path: '/' });
}

export function changeLanguage (lngCode: string) {
  setBackendLanguage(lngCode);

  localStorage.setItem(STORAGE_KEY, lngCode);
  return i18n.changeLanguage(lngCode);
}

if (Cookies.get('SSW_LOCALE')) {
  changeLanguage(Cookies.get('SSW_LOCALE') || '');
}


export default i18n
